import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Activity } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? decodeURIComponent(match[1]) : null;

    if (!session_id) { nav("/login", { replace: true }); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id }, { withCredentials: true });
        // Store token for Bearer fallback (cross-origin cookies are best-effort)
        if (data.token) localStorage.setItem("fl_token", data.token);
        setUser(data);
        // Clean fragment and route by role
        window.history.replaceState({}, document.title, window.location.pathname);
        const home = data.role === "patient" ? "/app" : data.role === "admin" ? "/admin" : "/clinician";
        nav(home, { replace: true });
      } catch (e) {
        nav("/login?error=google", { replace: true });
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen bg-[#0A0A0A] fl-noise flex items-center justify-center">
      <div className="text-center">
        <Activity className="text-[#f47a20] mx-auto animate-pulse" size={32} />
        <div className="fl-heading text-xl mt-4">Signing you in…</div>
        <div className="text-xs text-zinc-500 mt-2">Please wait a moment.</div>
      </div>
    </div>
  );
}
